module.exports = __webpack_public_path__ + "static/img/main_large_circle.bc42794.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/loading/main_large_circle.png
// module id = MeiW
// module chunks = 3